export default {
  title: 'Introduza o valor do reembolso',
  description: 'Disponível para reembolso: {{amount}}',
  form: {
    amount: {
      label: 'Reembolso',
    },
    reason: {
      label: 'Motivo',
      options: {
        requested_by_customer: 'pedido pelo cliente',
        reclamation: 'reclamação',
        communication_error: 'erro de comunicação',
        other: 'outro',
      },
    },
    manual_reason: {
      label: 'Introduza o motivo do reembolso',
    },
  },
  feedback: {
    amount_too_small: 'Valor mínimo de reembolso {{amount}}',
    amount_too_big: 'Valor máximo de reembolso {{amount}}',
    payment_frozen:
      'Reembolso já solicitado pelo cliente. {{provider}} está em contacto com o cliente sobre o reembolso',
  },
  buttons: {
    refund: 'Reembolso',
    cancel: 'Cancelar',
  },
  toasts: {
    refund_successful: 'O reembolso de {{amount}} foi iniciado com sucesso!',
  },
};
